import { createAggregatedClient } from "@smithy/smithy-client";
import { BatchEvaluateFeatureCommand, } from "./commands/BatchEvaluateFeatureCommand";
import { CreateExperimentCommand, } from "./commands/CreateExperimentCommand";
import { CreateFeatureCommand, } from "./commands/CreateFeatureCommand";
import { CreateLaunchCommand, } from "./commands/CreateLaunchCommand";
import { CreateProjectCommand, } from "./commands/CreateProjectCommand";
import { CreateSegmentCommand, } from "./commands/CreateSegmentCommand";
import { DeleteExperimentCommand, } from "./commands/DeleteExperimentCommand";
import { DeleteFeatureCommand, } from "./commands/DeleteFeatureCommand";
import { DeleteLaunchCommand, } from "./commands/DeleteLaunchCommand";
import { DeleteProjectCommand, } from "./commands/DeleteProjectCommand";
import { DeleteSegmentCommand, } from "./commands/DeleteSegmentCommand";
import { EvaluateFeatureCommand, } from "./commands/EvaluateFeatureCommand";
import { GetExperimentCommand, } from "./commands/GetExperimentCommand";
import { GetExperimentResultsCommand, } from "./commands/GetExperimentResultsCommand";
import { GetFeatureCommand } from "./commands/GetFeatureCommand";
import { GetLaunchCommand } from "./commands/GetLaunchCommand";
import { GetProjectCommand } from "./commands/GetProjectCommand";
import { GetSegmentCommand } from "./commands/GetSegmentCommand";
import { ListExperimentsCommand, } from "./commands/ListExperimentsCommand";
import { ListFeaturesCommand, } from "./commands/ListFeaturesCommand";
import { ListLaunchesCommand, } from "./commands/ListLaunchesCommand";
import { ListProjectsCommand, } from "./commands/ListProjectsCommand";
import { ListSegmentReferencesCommand, } from "./commands/ListSegmentReferencesCommand";
import { ListSegmentsCommand, } from "./commands/ListSegmentsCommand";
import { ListTagsForResourceCommand, } from "./commands/ListTagsForResourceCommand";
import { PutProjectEventsCommand, } from "./commands/PutProjectEventsCommand";
import { StartExperimentCommand, } from "./commands/StartExperimentCommand";
import { StartLaunchCommand } from "./commands/StartLaunchCommand";
import { StopExperimentCommand, } from "./commands/StopExperimentCommand";
import { StopLaunchCommand } from "./commands/StopLaunchCommand";
import { TagResourceCommand } from "./commands/TagResourceCommand";
import { TestSegmentPatternCommand, } from "./commands/TestSegmentPatternCommand";
import { UntagResourceCommand, } from "./commands/UntagResourceCommand";
import { UpdateExperimentCommand, } from "./commands/UpdateExperimentCommand";
import { UpdateFeatureCommand, } from "./commands/UpdateFeatureCommand";
import { UpdateLaunchCommand, } from "./commands/UpdateLaunchCommand";
import { UpdateProjectCommand, } from "./commands/UpdateProjectCommand";
import { UpdateProjectDataDeliveryCommand, } from "./commands/UpdateProjectDataDeliveryCommand";
import { EvidentlyClient } from "./EvidentlyClient";
const commands = {
    BatchEvaluateFeatureCommand,
    CreateExperimentCommand,
    CreateFeatureCommand,
    CreateLaunchCommand,
    CreateProjectCommand,
    CreateSegmentCommand,
    DeleteExperimentCommand,
    DeleteFeatureCommand,
    DeleteLaunchCommand,
    DeleteProjectCommand,
    DeleteSegmentCommand,
    EvaluateFeatureCommand,
    GetExperimentCommand,
    GetExperimentResultsCommand,
    GetFeatureCommand,
    GetLaunchCommand,
    GetProjectCommand,
    GetSegmentCommand,
    ListExperimentsCommand,
    ListFeaturesCommand,
    ListLaunchesCommand,
    ListProjectsCommand,
    ListSegmentReferencesCommand,
    ListSegmentsCommand,
    ListTagsForResourceCommand,
    PutProjectEventsCommand,
    StartExperimentCommand,
    StartLaunchCommand,
    StopExperimentCommand,
    StopLaunchCommand,
    TagResourceCommand,
    TestSegmentPatternCommand,
    UntagResourceCommand,
    UpdateExperimentCommand,
    UpdateFeatureCommand,
    UpdateLaunchCommand,
    UpdateProjectCommand,
    UpdateProjectDataDeliveryCommand,
};
export class Evidently extends EvidentlyClient {
}
createAggregatedClient(commands, Evidently);
